import http from "@/http-common";

/**
 * Service quản lý đăng ký khoản sử dụng (Managing Revenue)
 * Base URL: /web/receipt/v1/managing-revenue
 * Lưu ý: idSchool, idCreated, createdBy, idModified, lastModifiedBy KHÔNG cần truyền – BE tự inject từ JWT token.
 */

const BASE = "receipt/v1/managing-revenue";

class ManagingRevenueService {
  /**
   * API 1 — Chi tiết khoản thu theo Lớp
   * GET /web/receipt/v1/managing-revenue/class/details
   * @param {Object} params - { idClass, status?, fullName? }
   */
  getClassDetails(params) {
    return http.get(`${BASE}/class/details`, { params });
  }

  /**
   * API 2 — Chi tiết khoản thu theo Nhóm
   * GET /web/receipt/v1/managing-revenue/group/details
   * @param {Object} params - { idGroup, status?, fullName? }
   */
  getGroupDetails(params) {
    return http.get(`${BASE}/group/details`, { params });
  }

  /**
   * API 3 — Init + Tìm kiếm theo Lớp
   * POST /web/receipt/v1/managing-revenue/class/init-search
   * @param {Object} data - { idClass, status?, fullName? }
   * @returns { packageList: PackageSummaryItem[], dataList: StudentPackageRow[] }
   */
  initSearchByClass(data) {
    return http.post(`${BASE}/class/init-search`, data);
  }

  /**
   * API 4 — Init + Tìm kiếm theo Nhóm
   * POST /web/receipt/v1/managing-revenue/group/init-search
   * @param {Object} data - { idGroup, status?, fullName? }
   * @returns { packageList: PackageSummaryItem[], dataList: StudentPackageRow[] }
   */
  initSearchByGroup(data) {
    return http.post(`${BASE}/group/init-search`, data);
  }

  /**
   * API 4.1 — Chi tiết khoản thu theo Gói
   * GET /web/receipt/v1/managing-revenue/package/details
   * @param {Object} params - { idPackage, status?, fullName? }
   */
  getPackageDetails(params) {
    return http.get(`${BASE}/package/details`, { params });
  }

  /**
   * API 4.2 — Init + Tìm kiếm theo Gói
   * POST /web/receipt/v1/managing-revenue/package/init-search
   * @param {Object} data - { idPackage, status?, fullName? }
   * @returns { packageList: PackageSummaryItem[], dataList: StudentPackageRow[] }
   */
  initSearchByPackage(data) {
    return http.post(`${BASE}/package/init-search`, data);
  }

  /**
   * API 5 — Kích hoạt / Hủy kích hoạt khoản cho 1 học sinh
   * POST /web/receipt/v1/managing-revenue/active-one
   * @param {Object} data - { id, fullName?, fnKidsPackageList[] }
   */
  activeOne(data) {
    return http.post(`${BASE}/active-one`, data);
  }

  /**
   * API 6 — Kích hoạt / Hủy kích hoạt khoản cho nhiều học sinh
   * POST /web/receipt/v1/managing-revenue/active-many
   * @param {Array} data - [{ id, fullName?, fnKidsPackageList[] }]
   */
  activeMany(data) {
    return http.post(`${BASE}/active-many`, data);
  }

  /**
   * API 7 — Sửa thông tin tài chính khoản thu (ManagingRevenueStudent)
   * PUT /web/receipt/v1/managing-revenue/update-one
   * @param {Object} data - { id, price?, quantity?, unit?, discount?, discountType?, discountNumber?, issuingElectronicInvoices?, numberUnit? }
   * @returns { data: true | false }  (false = bản ghi không còn tồn tại)
   */
  updateOne(data) {
    return http.put(`${BASE}/update-one`, data);
  }

  /**
   * API 8 - Lấy chi tiết khoản đăng ký của học sinh
   */
  getDetailById(id){
    return http.get(`${BASE}/registered/${id}`);
  }

  // ─── Principal Override APIs ─────────────────────────────────────

  /**
   * API 9 — Lấy danh sách override khoản phụ
   * GET /web/receipt/v1/managing-revenue/principal-overrides/{idRevenueStudent}
   * @param {String} idRevenueStudent - UUID của ManagingRevenueStudent
   * @returns { data: StudentPrincipalOverrideResponse[] }
   */
  getPrincipalOverrides(idRevenueStudent) {
    return http.get(`${BASE}/principal-overrides/${idRevenueStudent}`);
  }

  /**
   * API 10 — Cập nhật override khoản phụ
   * PUT /web/receipt/v1/managing-revenue/principal-overrides
   * @param {Object} data - { idRevenueStudent, overrides: [...] }
   * @returns { data: StudentPrincipalOverrideResponse[] }
   */
  updatePrincipalOverrides(data) {
    return http.put(`${BASE}/principal-overrides`, data);
  }

  /**
   * API 11 — Reset override về mặc định
   * POST /web/receipt/v1/managing-revenue/principal-overrides/{idRevenueStudent}/reset
   * @param {String} idRevenueStudent - UUID của ManagingRevenueStudent
   * @returns { data: StudentPrincipalOverrideResponse[] }
   */
  resetPrincipalOverrides(idRevenueStudent) {
    return http.post(`${BASE}/principal-overrides/${idRevenueStudent}/reset`);
  }
}

export default new ManagingRevenueService();
